<template>
	<NewItem
		ref="newItem"
		button-title="New Project"
		:align-button="alignButton"
	>
		<template slot="form">
			<ProjectForm
				:existing-projects="existingProjects"
				@new-project="submit"
			>
				<v-btn
					slot="buttons"
					flat
					color="error"
					@click="$refs.newItem.show = false"
				>
					close
				</v-btn>
			</ProjectForm>
		</template>
	</NewItem>
</template>

<script>
import NewItem from '@/components/NewItem';
import ProjectForm from '@/components/Project/ProjectForm';

export default {
	components: {
		NewItem,
		ProjectForm,
	},
	props: {
		redirectOnCreate: { type: Boolean, default: true },
		alignButton: { type: String, default: 'center' },
		existingProjects: { type: Array, default: () => [] },
	},
	methods: {
		submit(project) {
			const projects = this.$store.get('projects/active');
			project.save().then(() => {
				// Add to store projects collection
				projects.add(project);

				if (this.redirectOnCreate) {
					this.$router.push({ name: 'ReportsList', params: { projectId: project.id } });
				}

				this.$notify('success', `Project ${project.name} has been created.`);
			}).catch((error) => {
				// Validation error can only occur if project name exists elsewhere
				if (error.response.response.status === 422) {
					this.$notify('error', `Name "${project.name}" has already been taken.`);
					return;
				}
				this.$notify('error', `Failed to create project ${project.name}.`);
			});
			this.$refs.newItem.close();
		},
	},
};
</script>

<style>

</style>
